import { DebitDefaultersComponent } from './components/debit-defaulters/debit-defaulters.component';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { RecoveryPasswordComponent } from './components/recovery-password/recovery-password.component';
import { RegisterComponent } from './components/register/register.component';
import { GeneralComponent } from './components/general/general.component';
import { AuthGuard } from './guards/auth.guard';
import { HomeComponent } from './components/home/home.component';
import { AccountComponent } from './components/account/account.component';
import { DependentCardComponent } from './components/dependent-card/dependent-card.component';
import { ExtractComponent } from './components/extract/extract.component';
import { RechargeComponent } from './components/recharge/recharge.component';
import { DependentSingleComponent } from './components/dependent-single/dependent-single.component';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { CreditCardSingleComponent } from './components/credit-card-single/credit-card-single.component';
import { DailyLimitComponent } from './components/daily-limit/daily-limit.component';
import { NutritionalComponent } from './components/nutritional/nutritional.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { DuplicatePayComponent } from './components/duplicate-pay/duplicate-pay.component';
import { RegisterDependentComponent } from './components/register-dependent/register-dependent.component';
import { RestrictionComponent } from './components/restriction/restriction.component';
import { RestrictionSingleComponent } from './components/restriction-single/restriction-single.component';
import { PyramidDescComponent } from './components/pyramid-desc/pyramid-desc.component';
import { ConfirmDuplicateComponent } from './components/confirm-duplicate/confirm-duplicate.component';
import { NgModule } from '@angular/core';
import { DefaultersComponent } from './components/defaulters/defaulters.component';
import { ReembolsoComponent } from './components/reembolso/reembolso.component';
import { PlanComponent } from './components/plan/plan.component';
import { PlanDetailComponent } from './components/plan-detail/plan-detail.component';
import { CurrentSubscriptionComponent } from './components/current-subscription/current-subscription.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';

const appRoutes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {title: 'Login'}
  },
  {
    path: 'esquecerSenha',
    component: ForgetPasswordComponent,
    data: {title: 'Esqueci minha senha'}
  },
  {
    path: 'RecuperarSenha/:token/:cpfOuEmail',
    component: RecoveryPasswordComponent,
    data: {title: 'Recuperar senha'}
  },
  {
    path: 'criarConta',
    component: RegisterComponent,
    data: {title: 'Criar conta'}
  },
  {
    path: 'termsAndConditions',
    component: TermsAndConditionsComponent,
    data: {title: 'Termos e Condições'}
  },
  {
    path: 'general',
    component: GeneralComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard],
        data: {title: 'Home'}
      },
      {
        path: 'debito/:id/:idCartao',
        component: DebitDefaultersComponent,
        pathMatch: 'full',
        canActivate: [AuthGuard],
        data: {title: 'Débito'}
      },
      {
        path: 'minhaConta',
        component: AccountComponent,
        data: {title: 'Minha Conta'},
        canActivate: [AuthGuard]
      },
      {
        path: 'cartoesDependentes',
        component: DependentCardComponent,
        data: {title: 'Cartões MEEP'},
        canActivate: [AuthGuard]
      },
      {
        path: 'extrato/:id/:tipo',
        component: ExtractComponent,
        data: {title: 'Extrato'},
        canActivate: [AuthGuard]
      },
      {
        path: 'recarga/:id/:tipo',
        component: RechargeComponent,
        data: {title: 'Recarga'},
        canActivate: [AuthGuard]
      },
      {
        path: 'dependentesSingle/:id/:tipo',
        component: DependentSingleComponent,
        data: {title: 'Configurações'},
        canActivate: [AuthGuard]
      },
      {
        path: 'reembolso/:id/:tipoCartao/:historicoAssociacaoId/:tipoReembolso',
        component: ReembolsoComponent,
        data: {title: 'Solicitar reembolso'},
        canActivate: [AuthGuard]
      },
      {
        path: 'cartoes',
        component: CreditCardComponent,
        data: {title: 'Cartões'},
        canActivate: [AuthGuard]
      },
      {
        path: 'registrarCartao',
        component: CreditCardSingleComponent,
        data: {title: 'Registrar Cartão'},
        canActivate: [AuthGuard]
      },
      {
        path: 'limiteDiario/:id',
        component: DailyLimitComponent,
        data: {title: 'Limite diário'},
        canActivate: [AuthGuard]
      },
      {
        path: 'dependentesSingle/:id/nutricional/:companyId',
        component: NutritionalComponent,
        data: {title: 'Nutricional'},
        canActivate: [AuthGuard]
      },
      {
        path: 'alterarSenha/:who/:id/:meepcard',
        component: ChangePasswordComponent,
        data: {title: 'Alterar dados'},
        canActivate: [AuthGuard]
      },
      {
        path: 'duplicatePay/:meepCardNumber',
        component: DuplicatePayComponent,
        data: {title: 'Solicitar 2ª via'},
        canActivate: [AuthGuard]
      },
      {
        path: 'registrarDependente',
        component: RegisterDependentComponent,
        data: {title: 'Registrar Dependentes'},
        canActivate: [AuthGuard]
      },
      {
        path: 'registrarDependente/:id',
        component: RegisterDependentComponent,
        data: {title: 'Registrar Dependentes'},
        canActivate: [AuthGuard]
      },
      {
        path: 'dependentesSingle/:id/restricoes/:companyId/:tipo',
        component: RestrictionComponent,
        data: {title: 'Cardápio'},
        canActivate: [AuthGuard]
      },
      {
        path: 'dependentesSingle/:id/restricoes/:companyId/restricaoSingle/:categoryId/:tipo',
        component: RestrictionSingleComponent,
        data: {title: 'Restrições categoria'},
        canActivate: [AuthGuard]
      },
      {
        path: 'cartoesDependentes',
        component: DependentCardComponent,
        data: {title: 'Cartões dependentes'},
        canActivate: [AuthGuard]
      },
      {
        path: 'descricaoPiramide',
        component: PyramidDescComponent,
        data: {title: 'Descrição Piramide'},
        canActivate: [AuthGuard]
      },
      {
        path: 'segundaVia/:meepCardNumber',
        component: ConfirmDuplicateComponent,
        data: {title: 'Segunda Via'},
        canActivate: [AuthGuard]
      },
      {
        path: 'defaultersDependents',
        component: DefaultersComponent,
        data: {title: 'Devedores'},
        canActivate: [AuthGuard]
      },
      {
        path: 'plan',
        component: PlanComponent,
        data: {title: 'Planos'},
        canActivate: [AuthGuard]
      },
      {
        path: 'planDetail/:planId',
        component: PlanDetailComponent,
        data: {title: 'Detalhes do Plano'},
        canActivate: [AuthGuard]
      },
      {
        path: 'currentSubscription',
        component: CurrentSubscriptionComponent,
        data: {title: 'Planos Vigentes'},
        canActivate: [AuthGuard]
      },
      {
        path: 'notificacoes/:id',
        component: NotificationsComponent,
        data: {title: 'Notificações'},
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '**',
    component: LoginComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// /usr/src/app/src/app/app.routing.module.ts